import React from 'react';

var Dislike = function Dislike(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "Dislike"), /*#__PURE__*/React.createElement("path", {
    d: "M4.574 14a.074.074 0 0 1-.074-.074V6.075c0-.041.033-.074.074-.074H6.5v8H4.574zm0 2H8.5V4H4.574A2.074 2.074 0 0 0 2.5 6.076v7.851c0 1.146.929 2.075 2.074 2.075zM8.5 14.674V6.037c3.266-1.008 6.03-1.276 8.292-.825 1.512.302 2.244.855 2.537 1.605.152.385.184.755.165 1.406-.005.196-.006.231-.006.313v5.465c0 .378-.716 1-1.339 1H13.5a1 1 0 0 0-1 .998l-.005 3.583a.074.074 0 0 1-.052.07l-.985.305a.943.943 0 0 1-1.16-.565L8.5 14.673zm9.65 2.328c1.668 0 3.338-1.45 3.338-3V8.536c0-.053 0-.085.005-.254.027-.903-.025-1.49-.301-2.195-.557-1.421-1.862-2.408-4.01-2.836-2.797-.558-6.128-.18-9.998 1.108a1 1 0 0 0-.684.949v9.55a1 1 0 0 0 .066.356l1.864 4.89a2.943 2.943 0 0 0 3.619 1.764l.985-.304a2.074 2.074 0 0 0 1.461-1.98l.004-2.583h3.65z",
    fill: "currentColor"
  }));
};

Dislike.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
import iconHandler from './hoc';
export { Dislike as icon };
export default iconHandler(Dislike);